/**
 * Returns true when a nav link URL matches the current page.
 * - For path-only links, compares pathname only.
 * - For links with query params, every param in the nav link URL must also
 *   match the current page's search params. This handles shared-path links
 *   (e.g. /shop/stores/search?category_name=alcohol vs category_name=produce).
 */
export const isNavLinkActive = (
  url: string,
  pathname: string | null,
  searchParams: URLSearchParams | null,
): boolean => {
  const targetUrl = new URL(url, 'https://example.com')
  return (
    targetUrl.pathname === pathname &&
    [...targetUrl.searchParams.entries()].every(([key, value]) => searchParams?.get(key) === value)
  )
}
